<!-- Direction -->
<div class="sum-results-display" *ngIf="aggregatedValues">
  <div
    class="results-row-multiple-values results-row-multiple-values--top-header"
  >
    <div class="direction">Opposite Direction</div>

    <div class="position">Position As Shown</div>
  </div>

  <!-- Receive/Pay -->
  <div class="results-row-multiple-values">
    <div class="direction">{{ aggregatedValues.headers?.bid }}</div>
    <div class="position">{{ aggregatedValues.headers?.ask }}</div>
  </div>

  <!-- Upfront premium (no hide) -->
  <div class="results-row-multiple-values">
    <div
      class="direction"
      *ngIf="aggregatedValues.premiumQuoteCurrency?.bid != null"
    >
      {{ cross.term }}
      {{ +aggregatedValues.premiumQuoteCurrency.bid | abs | number: '1.0-0' }}
    </div>

    <div
      class="position"
      *ngIf="aggregatedValues.premiumQuoteCurrency?.ask != null"
    >
      {{ cross.term }}
      {{ +aggregatedValues.premiumQuoteCurrency.ask | abs | number: '1.0-0' }}
    </div>
  </div>

  <!-- premiumQuoteCurrencyInPercent -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.premiumQuoteCurrencyInPercent"
  >
    <div
      class="direction"
      *ngIf="aggregatedValues.premiumQuoteCurrencyInPercent?.bid != null"
    >
      {{ cross.term }}
      {{
        aggregatedValues.premiumQuoteCurrencyInPercent.bid | percent: '1.4-4'
      }}
    </div>

    <div
      class="position"
      *ngIf="aggregatedValues.premiumQuoteCurrencyInPercent?.ask != null"
    >
      {{ cross.term }}
      {{
        aggregatedValues.premiumQuoteCurrencyInPercent.ask | percent: '1.4-4'
      }}
    </div>
  </div>

  <!-- premiumQuoteCurrencyPips -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.premiumQuoteCurrencyPips"
  >
    <div
      class="direction"
      *ngIf="aggregatedValues.premiumQuoteCurrencyPips?.bid != null"
    >
      {{ cross.term }}
      {{ aggregatedValues.premiumQuoteCurrencyPips.bid | number: '1.2-2' }}
    </div>

    <div
      class="position"
      *ngIf="aggregatedValues.premiumQuoteCurrencyPips?.ask != null"
    >
      {{ cross.term }}
      {{ aggregatedValues.premiumQuoteCurrencyPips.ask | number: '1.2-2' }}
    </div>
  </div>

  <!-- premiumBaseCurrency -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.premiumBaseCurrency"
  >
    <div
      class="direction"
      *ngIf="aggregatedValues.premiumBaseCurrency?.bid != null"
    >
      {{ cross.base }}
      {{ +aggregatedValues.premiumBaseCurrency.bid | abs | number: '1.0-0' }}
    </div>

    <div
      class="position"
      *ngIf="aggregatedValues.premiumBaseCurrency?.ask != null"
    >
      {{ cross.base }}
      {{ +aggregatedValues.premiumBaseCurrency.ask | abs | number: '1.0-0' }}
    </div>
  </div>

  <!-- premiumBaseCurrencyInPercent -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.premiumBaseCurrencyInPercent"
  >
    <div
      class="direction"
      *ngIf="aggregatedValues.premiumBaseCurrencyInPercent?.bid != null"
    >
      {{ cross.base }}
      {{
        +aggregatedValues.premiumBaseCurrencyInPercent.bid | percent: '1.4-4'
      }}
    </div>

    <div
      class="position"
      *ngIf="aggregatedValues.premiumBaseCurrencyInPercent?.ask != null"
    >
      {{ cross.base }}
      {{
        +aggregatedValues.premiumBaseCurrencyInPercent.ask | percent: '1.4-4'
      }}
    </div>
  </div>

  <!-- upfrontPremiumBsMid -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.upfrontPremiumBsMid"
  >
    <ng-container *ngIf="aggregatedValues.blackScholesMidTv != null">
      {{ cross.term }}
      {{ aggregatedValues.blackScholesMidTv | number: '1.0-0' }}
    </ng-container>
  </div>

  <!-- spotDelta -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.spotDelta"
  >
    <ng-container *ngIf="aggregatedValues.delta != null">
      {{ cross.base }}
      {{ aggregatedValues.delta | number: '1.0-0' }}
    </ng-container>
  </div>

  <!-- spotDeltaPercent -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.spotDeltaPercent"
  ></div>

  <!-- forwardDelta -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.forwardDelta"
  ></div>

  <!-- forwardDeltaPercent -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.forwardDeltaPercent"
  ></div>

  <!-- brokerDelta -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.brokerDelta"
  ></div>

  <!-- brokerDeltaPercent -->
  <div
    class="results-row-multiple-values"
    *ngIf="pricingResultsExpanded && rowsToShow.brokerDeltaPercent"
  ></div>

  <!-- gamma -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.gamma"
  >
    <ng-container *ngIf="aggregatedValues.gamma != null">
      {{ cross.base }}

      {{ aggregatedValues.gamma | number: '1.0-0' }}
    </ng-container>
  </div>

  <!-- vega -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.vega"
  >
    <ng-container *ngIf="aggregatedValues.vega != null">
      {{ cross.base }}
      {{ aggregatedValues.vega | number: '1.2-2' }}
    </ng-container>
  </div>

  <!-- riskies -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.riskies"
  >
    <ng-container *ngIf="aggregatedValues.riskies != null">
      {{ cross.term }}
      {{ aggregatedValues.riskies | number: '1.2-2' }}
    </ng-container>
  </div>

  <!-- flies -->
  <div
    class="results-row-multiple-values results-row-multiple-values--center"
    *ngIf="pricingResultsExpanded && rowsToShow.flies"
  >
    <ng-container *ngIf="aggregatedValues.flies != null">
      {{ cross.term }}
      {{ aggregatedValues.flies | number: '1.2-2' }}
    </ng-container>
  </div>
</div>
